import request from "@/utils/request";
import { AxiosRequestConfig } from "axios";
/* eslint-disable */

const ajax = (config: AxiosRequestConfig): Promise<any> => {

    const p = new Promise<any>(async (resolve, reject) => {
        try {
            const req = await request(config)
            resolve(req)
        } catch (e) {
            console.log(e)
            reject(e)
        }
    })
    return p
}

/**
 * 上传图片
 * @param file 本地拿到的文件
 */
export function uploadFile(file: any) {
    const data = new FormData()
    data.append('image', file)
    return request({
        method: 'post',
        url: '/api/image',
        data: data,
        headers: { 'Content-Type': 'multipart/form-data' },
    })
}




/**
 * 根据sim卡类型获取地区名
 * @param type 1 联通 2 移动 3 电信
 * @returns 
 */
export const getSysLocation = (type: number, aid: number): Promise<Rsp<GetSysLocationRsp>> => {
    return ajax({
        method: 'get',
        url: '/api/sys/location/',
        params: { type, aid }
    })
}

/**
 * 获取某商户下的所有应用
 * @param id 商户 id
 */
export const getAppMerchant = (id: number): Promise<Rsp<GetAppMerchantRsp>> => {
    return ajax({
        method: 'get',
        url: '/api/app/merchant/',
        params: { id }
    })
}

/**
 * 根据链接获取应用信息
 * @param code 链接邀请码
 */
export const getAppLink = (lid: number, id: number): Promise<Rsp<AppLinkRsp>> => {
    return ajax({
        method: 'get',
        url: '/api/app/link/',
        params: { lid, id }
    })
}

/**
 * 根据协议类型获取协议内容
 */
export const getProtocol = (type: string): Promise<Rsp<GetSysProtocolRsp>> => {
    return ajax({
        method: 'get',
        url: '/api/sys/protocol/',
        params: { type }
    })
}

/**
 * 选择手机号列表
 * @param prefix 号段 - 可选
 * @param value 号码 - 可选
 */
export const getAppChoose = (id: number, prefix: string, value: string): Promise<Rsp<GetAppChooseRsp>> => {
    return ajax({
        method: 'post',
        url: '/api/app/choose/',
        params: { id, prefix, value }
    })
}

export const sumbitOrder = (data: {}): Promise<Rsp<OrderAddRsp>> => {
    return ajax({
        method: 'post',
        url: '/api/order/add/',
        data: data
    })
}

/**
 * 查询订单信息
 * @param id 身份号
 * @param name 姓名
 */
export const orderQuery = (id: string): Promise<Rsp<OrderQueryRsp>> => {
    return ajax({
        method: 'post',
        url: '/api/order/query/',
        data: { id }
    })
}

/**
 * 查询快递信息
 * @param order_id 订单ID
 */
export const orderExpress = (order_id: string): Promise<Rsp<OrderExpressRsp>> => {
    return ajax({
        method: 'post',
        url: '/api/order/express/',
        data: { order_id }
    })
}


/**
 * 查询商户下的所有信息
 * @param id 商户ID
 * @param lid 链接ID
 */
export const appMerchent = (lid: number, id: number = 0): Promise<Rsp<GetAppMerchantRsp>> => {
    return ajax({
        method: 'get',
        url: '/api/app/merchant/',
        params: { id, lid }
    })
}

/**
 * 获取广告信息
 */
export const fetchAd = (position: string): Promise<Rsp<SysAdRsp>> => {
    return ajax({
        method: 'post',
        url: '/api/sys/ad/',
        data: {
            position,
        }
    })
}

/**
 * @param type 1 展示, 2 点击
 */
export const adStat = (name: string, type: 1|2, position: string): Promise<Rsp<any>> => {
    return ajax({
        method: 'post',
        url: '/api/sys/stat/',
        data: {name, type, position}
    })
}

// SIM 卡埋点埋点
export const setSysTrack = (data: SysTrackReq): Promise<Rsp<SysTrackRsp>> => {
	return ajax({
        method: 'post',
        url: '/api/sys/track/',
        data: data,
    })
}

/**
 * 查询快递信息
 */
export const fetchSystemLink = (): Promise<Rsp<SystemLinkRsp>> => {
    return ajax({
        method: 'get',
        url: '/api/sys/link/'
    })
}

/** 用户登录/注册 */
export const linkUserLogin = (mobile: string, password: string, link_id: number, merchant_id: number): Promise<Rsp<SystemLoginRsp>> => {
    return ajax({
        method: 'post',
        url: '/api/sys/login/',
        data: {mobile, password, link_id, merchant_id}
    })
}

/**
 * 获取登录信息
 */
export const linkLoginInfo = (merchant_id: number): Promise<Rsp<SystemLoginRsp>> => {
    return ajax({
        method: 'get',
        url: '/api/sys/my_link/',
        params: {merchant_id}
    })
}